import gql from 'graphql-tag';

export const GET_SCRATCH_PLATES_FOR_NOTE_PART_QUERY = gql`
  query GetScratchPlatesForNotePart($ids: [StrictString!]!) @skipAudit @engComponent(name: NOTEBOOK) {
    scratchPlates(ids: $ids) {
      ... on ScratchPlateNode {
        id
        name
        barcode
        createdAt
        width
        height
        isHidden
        plateSchema {
          ... on PlateSchemaNode {
            id
          }
          ... on InaccessibleInfoNode {
            invalidId
          }
        }
        summary {
          wellStates {
            rowIndex
            columnIndex
          }
        }
        inventoryPlate {
          ... on PlateNode {
            id
          }
          ... on InaccessibleInfoNode {
            invalidId
          }
        }
      }
      ... on InaccessibleInfoNode {
        invalidId
      }
    }
  }
`;
